import EditFormGroup from "components/form/EditFormGroup";
import { statusOption } from "pages/staff/StaffComponent";
import React, { forwardRef } from "react";

export default forwardRef(function CustomerForm(
  {
    data = {},
    onChange = () => {},
    onChangePhoneCode = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
    actionType = "add",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "email",
            label: "Email",
            type: "email",
            required: true,
            size: "small",
            readOnly: actionType === "add" ? false : true,
          },
          {
            name: "name",
            label: "Name",
            type: "text",
            required: true,
            size: "small",
          },
          {
            name: "phone",
            label: "Phone Number",
            placeholder: "Phone Number",
            type: "phone_input",
            required: true,
            startIcon: "PhoneOutlined",
            onChangePhoneCode: (v) => onChangePhoneCode(v),
          },
          // {
          //   name: "address",
          //   label: "Region",
          //   type: "address",
          //   readOnly: true,
          //   size: "small",
          // },
          ...(actionType === "add"
            ? [
                {
                  name: "password",
                  label: "Password",
                  type: "password",
                  required: true,
                  size: "small",
                },
                {
                  name: "password_confirm",
                  label: "Confirm Password",
                  type: "password",
                  required: true,
                  size: "small",
                },
              ]
            : [
                {
                  name: "status",
                  label: "Status",
                  type: "select",
                  options: statusOption,
                  optionLabel: (option) => option.label,
                  size: "small",
                },
              ]),

          // {
          //   name: "spent",
          //   label: "Spent",
          //   type: "money",
          //   readOnly: true,
          //   size: "small",
          // },
          // {
          //   name: "card_name",
          //   label: "Card Name",
          //   type: "text",
          //   size: "small",
          // },
          // {
          //   name: "card_number",
          //   label: "Card Number",
          //   type: "card_number",
          //   size: "small",
          // },
          // {
          //   name: "card_expire",
          //   label: "Card Expire",
          //   type: "date",
          //   size: "small",
          // },
          // {
          //   name: "card_cvv",
          //   label: "Card CVV",
          //   type: "card_cvv",
          //   size: "small",
          // },
        ]}
        isLabel
        fullWidth={true}
        direction="column"
        spacing={2}
      />
    </div>
  );
});
